/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { RubricRowBase } from './RubricRowBase';
const NewRubricMappingItemParser = 
/* #__PURE__ */ parsers.object([
    ['originalId', codecNumber, 'original_id'],
    ['newRow', RubricRowBase, 'new_row'],
]);
export class NewRubricMappingItem extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return NewRubricMappingItemParser.decode(input).map(res => new NewRubricMappingItem(res));
    }
    static unsafeDecode(input) {
        return NewRubricMappingItem.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NewRubricMappingItemParser.encode(data);
    }
    static schema() {
        return NewRubricMappingItemParser.schema();
    }
}
